import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const YandexAnalytics = ({ service, isPageLoading, className }) => {
	useEffect(() => {
		/* eslint-disable */
		window.ym =
			window.ym ||
			function () {
				(window.ym.a = window.ym.a || []).push(arguments);
			};
		window.ym.l = 1 * new Date();
		/* eslint-enable */

		window.ym(service.analyticsId, 'init', {
			clickmap: true,
			trackLinks: true,
			accurateTrackBounce: true,
			webvisor: true
		});
	}, []);

	useEffect(() => {
		if (!isPageLoading) {
			const script = document.createElement('script');
			script.async = true;
			script.src = 'https://mc.yandex.ru/metrika/tag.js';

			const head = document.head || document.getElementsByTagName('head')[0];
			head.appendChild(script);
		}
	}, [isPageLoading]);

	return (
		<div className={className}>
			<a
				href={`https://metrika.yandex.ru/stat/?id=${service.analyticsId}&amp;from=informer`}
				target="_blank"
				rel="nofollow noopener"
				tabIndex={-1}
			>
				<img
					className="ym-advanced-informer"
					src={`https://informer.yandex.ru/informer/${service.analyticsId}/3_0_FFFFFFFF_EFEFEFFF_0_pageviews`}
					style={{ width: '88px', height: '31px', border: 0 }}
					alt="Яндекс.Метрика"
					title="Яндекс.Метрика: данные за сегодня (просмотры, визиты и уникальные посетители)"
					data-cid={service.analyticsId}
					data-lang="ru"
				/>
			</a>
		</div>
	);
};

YandexAnalytics.propTypes = {
	service: PropTypes.shape({
		analyticsId: PropTypes.number.isRequired
	}).isRequired,
	isPageLoading: PropTypes.bool.isRequired,
	className: PropTypes.string
};

export default YandexAnalytics;
